module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('box', {
    attrs: {
      "title": "Filtro"
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filtro === 'ID'),
      expression: "filtro==='ID'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "34px"
    },
    attrs: {
      "type": "number",
      "placeholder": "Pesquisa por ID"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filtro === 'NOME'),
      expression: "filtro==='NOME'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.filter_name),
      expression: "filter_name"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "34px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Pesquisa por NOME"
    },
    domProps: {
      "value": (_vm.filter_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter_name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v(_vm._s(_vm.filtro) + " "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu dropdown-menu-right"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.filtro = 'ID';
        _vm.filter = _vm.filter_name;
        _vm.filter_name = ''
      }
    }
  }, [_vm._v("ID")])]), _vm._v(" "), _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.filtro = 'NOME';
        _vm.filter_name = _vm.filter;
        _vm.filter = ''
      }
    }
  }, [_vm._v("Nome")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.status),
      expression: "status"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "exampleFormControlSelect1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.status = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("Todos Estados")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("Em Espera")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("Aprovado")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 4
    }
  }, [_vm._v("Reprovado")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 5
    }
  }, [_vm._v("Personalizado")])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "col-md-2 btn-group",
    attrs: {
      "data-toggle": "buttons"
    }
  }, [_c('label', {
    staticClass: "btn btn-primary radioOntem",
    attrs: {
      "id": "radioOntem"
    },
    on: {
      "click": function($event) {
        return _vm.filtrarData('ontem')
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "autocomplete": "off"
    }
  }), _vm._v(" Ontem\n                  ")]), _vm._v(" "), _c('label', {
    staticClass: "btn btn-primary radioHoje",
    attrs: {
      "id": "radioHoje"
    },
    on: {
      "click": function($event) {
        return _vm.filtrarData('hoje')
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "autocomplete": "off"
    }
  }), _vm._v(" Hoje\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon",
    staticStyle: {
      "background": "#367FA9",
      "color": "white"
    },
    attrs: {
      "id": "sizing-addon1"
    }
  }, [_vm._v("Data Inicial")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataInicial),
      expression: "dataInicial"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "34px"
    },
    attrs: {
      "type": "date",
      "aria-describedby": "sizing-addon1"
    },
    domProps: {
      "value": (_vm.dataInicial)
    },
    on: {
      "change": _vm.filtrarData,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dataInicial = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon",
    staticStyle: {
      "background": "#367FA9",
      "color": "white"
    },
    attrs: {
      "id": "sizing-addon2"
    }
  }, [_vm._v("Data Final")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataFinal),
      expression: "dataFinal"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "34px"
    },
    attrs: {
      "type": "date",
      "aria-describedby": "sizing-addon2"
    },
    domProps: {
      "value": (_vm.dataFinal)
    },
    on: {
      "change": _vm.filtrarData,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dataFinal = $event.target.value
      }
    }
  })])])])])]), _vm._v(" "), _c('box', [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "dataTables_length",
    attrs: {
      "id": "example1_length"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-borde#F48668 table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', _vm._l((_vm.colunas), function(coluna) {
    return _c('th', [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.orderPedidos(coluna.json)
        }
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-7"
    }, [_vm._v("\n                                  " + _vm._s(_vm._f("ucwords")(coluna.name)) + "\n                                ")]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2"
    }, [(_vm.order.keys === coluna.json && _vm.order.sort === 'asc') ? _c('i', {
      staticClass: "fa fa-sort-asc",
      attrs: {
        "aria-hidden": "true"
      }
    }) : (_vm.order.keys === coluna.json && _vm.order.sort === 'desc') ? _c('i', {
      staticClass: "fa fa-sort-desc",
      attrs: {
        "aria-hidden": "true"
      }
    }) : (coluna.json !== 'observacao') ? _c('i', {
      staticClass: "fa fa-sort",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e()])])])])
  }), 0)]), _vm._v(" "), _c('tbody', [(_vm.solicitacoesFiltered.length === 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("Nenhum Pedido Localizado")])]) : _vm._l((_vm.solicitacoesFiltered), function(p, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_c('router-link', {
      staticClass: "padding",
      attrs: {
        "to": {
          name: 'Detalhe Solicitação',
          params: {
            id: p.id
          }
        }
      }
    }, [_vm._v("\n                            " + _vm._s(p.id) + "\n                          ")])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("upperCase")(p.Clientes.nome)))]), _vm._v(" "), _c('td', {
      attrs: {
        "id": "obs"
      }
    }, [_vm._v(_vm._s(p.Pacotes ? p.Pacotes.titulo : 'Pacote Personalizado'))]), _vm._v(" "), _c('td', [_vm._v("R$ " + _vm._s(p.Pacotes ? p.Pacotes.preco.toFixed(2) : 0))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("data")(p.datahora)))]), _vm._v(" "), (p.statusid == 2) ? _c('td', {
      staticClass: "coluna"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (p.statusid),
        expression: "p.statusid"
      }],
      staticClass: "form-control",
      staticStyle: {
        "background": "#FFF95B",
        "border-color": "#FFF95B",
        "padding": "0px"
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(p, "statusid", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.gravarEstado(p.id, p.statusid)
        }]
      }
    }, _vm._l((_vm.estados), function(e) {
      return _c('option', {
        domProps: {
          "value": e.id
        }
      }, [_vm._v(_vm._s(e.descricao))])
    }), 0)]) : _vm._e(), _vm._v(" "), (p.statusid == 3) ? _c('td', {
      staticClass: "coluna"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (p.statusid),
        expression: "p.statusid"
      }],
      staticClass: "form-control",
      staticStyle: {
        "background": "#88D89D",
        "border-color": "#88D89D",
        "padding": "0px"
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(p, "statusid", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.gravarEstado(p.id, p.statusid)
        }]
      }
    }, _vm._l((_vm.estados), function(e) {
      return _c('option', {
        domProps: {
          "value": e.id
        }
      }, [_vm._v(_vm._s(e.descricao))])
    }), 0)]) : _vm._e(), _vm._v(" "), (p.statusid == 4) ? _c('td', {
      staticClass: "coluna"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (p.statusid),
        expression: "p.statusid"
      }],
      staticClass: "form-control",
      staticStyle: {
        "background": "#F48668",
        "border-color": "#F48668",
        "padding": "0px"
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(p, "statusid", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.gravarEstado(p.id, p.statusid)
        }]
      }
    }, _vm._l((_vm.estados), function(e) {
      return _c('option', {
        domProps: {
          "value": e.id
        }
      }, [_vm._v(_vm._s(e.descricao))])
    }), 0)]) : _vm._e(), _vm._v(" "), (p.statusid == 5) ? _c('td', {
      staticClass: "coluna"
    }, [_c('select', {
      staticClass: "form-control",
      staticStyle: {
        "padding": "0px"
      },
      attrs: {
        "disabled": ""
      }
    }, [_c('option', [_vm._v("Personalizado")])])]) : _vm._e()])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_c('label', [_vm._v("Total")])]), _vm._v(" "), _c('td', [_c('label', [_vm._v("R$ " + _vm._s(_vm.totalPedidos))])])])], 2), _vm._v(" "), _c('tfoot')])])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-827f893e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Solicitacoes/Solicitacoes.vue
// module id = 1276
// module chunks = 1